import { Award, Sparkles, Users, Heart } from "lucide-react";

const PILLARS = [
  {
    icon: Award,
    title: "Best Salon · 13 Years Running",
    body: "Voted Mississauga's favourite by the people who matter most — our guests.",
  },
  {
    icon: Sparkles,
    title: "Four Decades of Craft",
    body: "From the first blowout to the most intricate balayage, our chairs have shaped this city's style for over 40 years.",
  },
  {
    icon: Users,
    title: "Schwarzkopf Certified Team",
    body: "Every stylist is continuously trained in the world's finest colour systems, cuts and care.",
  },
  {
    icon: Heart,
    title: "Free Consultations, Always",
    body: "Your hair story is personal. Sit with us, talk it through — no pressure, no clock.",
  },
];

export default function Awards() {
  return (
    <section
      id="about"
      data-testid="awards-section"
      className="relative py-24 lg:py-36"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left heading */}
          <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
            <span className="overline">The Flavio&apos;s Difference</span>
            <h2 className="mt-6 font-serif font-light text-5xl lg:text-6xl text-ink-900 leading-[1.05] tracking-tight">
              Four decades.<br />
              <span className="italic text-gold">One obsession.</span>
            </h2>
            <p className="mt-8 text-lg text-ink-500 leading-relaxed max-w-md">
              We&apos;re a full-service beauty salon dedicated to making you
              feel and look your very best. Whether it&apos;s a simple
              haircut or a complete renewal, our goal is simple — give you
              exactly what you want, with the undivided attention you
              deserve.
            </p>
          </div>

          {/* Right pillars grid */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-black/10">
              {PILLARS.map((p, i) => (
                <div
                  key={p.title}
                  data-testid={`pillar-${i}`}
                  className="bg-sand-50 p-8 lg:p-10 flex flex-col min-h-[240px] hover:bg-sand-100 transition-colors duration-500"
                >
                  <p.icon className="w-7 h-7 text-gold" strokeWidth={1.25} />
                  <h3 className="mt-6 font-serif text-2xl lg:text-3xl text-ink-900 leading-tight">
                    {p.title}
                  </h3>
                  <p className="mt-4 text-sm text-ink-500 leading-relaxed">
                    {p.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
